import { setAlert } from '../../alert';
import { getConfig, getFormDataConfig } from '../constants/00-base-constants';
import {
    API_POST_REFRIGERANT_GAS_DATA,
    API_GET_REFRIGERANT_GAS_DATA,
    API_GET_REFRIGERANT_GAS_DATA_TOTALS
} from '../constants/01-direct-ghg-emissions-and-removals-constants';

import {
    POST_REFRIGERANT_GAS_DATA_SUCCESS,
    POST_REFRIGERANT_GAS_DATA_FAIL,
    GET_REFRIGERANT_GAS_DATA_SUCCESS,
    GET_REFRIGERANT_GAS_DATA_FAIL,
    GET_REFRIGERANT_GAS_DATA_TOTALS_SUCCESS,
    GET_REFRIGERANT_GAS_DATA_TOTALS_FAIL
} from '../types/01-direct-ghg-emissions-and-removals-types';

import api from '../../../util/api';

export const postRefrigerantGasData = (formData, year, company, group, facility, month) => async dispatch => {
    try {
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_REFRIGERANT_GAS_DATA + `/${year}/${company}/${group}/${facility}/${month}`,
            formData,
            getFormDataConfig()
        );
        dispatch({
            type: POST_REFRIGERANT_GAS_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_REFRIGERANT_GAS_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getRefrigerantGasData = (year, facility, rowsPerPage, currentPage, month) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_REFRIGERANT_GAS_DATA + `/${year}/${facility}/${rowsPerPage}/${currentPage}/${month}`,
            getConfig()
        );
        dispatch({
            type: GET_REFRIGERANT_GAS_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_REFRIGERANT_GAS_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getRefrigerantGasDataTotals = (year, facility) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_REFRIGERANT_GAS_DATA_TOTALS + `/${year}/${facility}`,
            getConfig()
        );
        dispatch({
            type: GET_REFRIGERANT_GAS_DATA_TOTALS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_REFRIGERANT_GAS_DATA_TOTALS_FAIL,
            payload: err.response.data.detail,
        });
    }
};
